module.exports = __webpack_public_path__ + "img/bestprice.b03d9c15.svg";